module.exports = "/_next/static/images/icon-3b8e4fd018497e9e9bad190d0d15fda6.png";